import { useEffect, useRef } from "react";

import { shouldSendActivityHeartbeat } from "~/helpers/activityHeartbeatGate";
import useUserActivityMutations from "~/hooks/mutations/useUserActivityMutations";

const INTERACTION_EVENTS = ["pointerdown", "keydown", "touchstart"] as const;

const useActivityHeartbeat = (enabled: boolean): void => {
	const { recordUserActivity } = useUserActivityMutations();
	const lastInteractionAtRef = useRef<number | null>(null);
	const lastSentAtRef = useRef<number | null>(null);

	useEffect(() => {
		if (!enabled) return;

		const handleInteraction = () => {
			const now = Date.now();
			lastInteractionAtRef.current = now;
			if (
				!shouldSendActivityHeartbeat({
					lastInteractionAt: lastInteractionAtRef.current,
					lastSentAt: lastSentAtRef.current,
					now
				})
			)
				return;
			lastSentAtRef.current = now;
			void recordUserActivity();
		};

		for (const eventName of INTERACTION_EVENTS) {
			window.addEventListener(eventName, handleInteraction, { passive: true });
		}
		return () => {
			for (const eventName of INTERACTION_EVENTS) {
				window.removeEventListener(eventName, handleInteraction);
			}
		};
	}, [enabled, recordUserActivity]);
};

export default useActivityHeartbeat;
